<template>
  <div class="insight-card">
    <GenericCard
      :key="item.id"
      :card-url="ctaUrl"
      :category="first(item.insightCategory) ?? ''"
      :content="item.content"
      :cta-link="ctaUrl"
      :custom-element-content="item.richTextCustomElement"
      :date="item.publishingDate"
      :description="item.shortDescription"
      :image="item.imgSrc"
      :title="item.title"
      :isFeatured="item.isFeatured"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import type { SearchResultInsightItem } from '~/types/SearchResultItem'
import first from 'lodash/first'

const pageStore = usePageStore()
const props = defineProps<{ item: SearchResultInsightItem }>()
const ctaUrl = ref('')

// Fetch the URL asynchronously after component mounts
onMounted(async () => {
  ctaUrl.value = (await pageStore.getUrlByItemId(props.item.id)) ?? ''
})
</script>
